(function () {
  function initEarlyBirdDealModal() {
    var dialog = document.getElementById('EarlyBirdDealModal');
    if (!dialog || dialog.dataset.earlyBirdReady === 'true') return;
    dialog.dataset.earlyBirdReady = 'true';

    function openModal() {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('early-bird-deal-modal-open');
    }

    function closeModal() {
      if (typeof dialog.close === 'function') {
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      document.documentElement.classList.remove('early-bird-deal-modal-open');
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-early-bird-deal-open]');
      if (opener) {
        event.preventDefault();
        event.stopPropagation();
        openModal();
        return;
      }

      if (event.target.closest('[data-early-bird-deal-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeModal();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('early-bird-deal-modal-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEarlyBirdDealModal);
  } else {
    initEarlyBirdDealModal();
  }
})();
